<iframe
    *ngIf="safeUrl"
    (window:resize)=onResize($event)
    #iframe
    [src]='safeUrl'
    width="100%"
    [height]="playerHeight"
    frameborder='0'
    allowfullscreen></iframe>